import { AddressDetailsModel } from '../client/client.model';

export interface AdvisorAppSettingsModel {
  showVinsafe: boolean;
}

export class AdvisorDetailsModel {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  officePhoneNumber: string;
  gpNumber: string;
  profilePictureUrl: string;
  pin: string;
  companyName: string;
  address: AddressDetailsModel;
  partnerLinks: PartnerLinkModel[];
  userFeatures: string[];
  enabledFeatureFlags: string[];
}

export class MainAdvisorModel {
  userId: string;
  firstName: string;
  lastName: string;
  profilePictureUrl: string;
  canHaveClients: boolean;
  absentUntil?: string | null; // 'YYYY-MM-DD', set while the advisor is absent
}

export class AssignedAdvisorModel {
  userId: string;
  firstName: string;
  lastName: string;
  profilePictureUrl: string;
  mainAdvisor: boolean;
  specialization: string;
  email: string;
}

export class PartnerLinkModel {
  id: number;
  title: string;
  description: string;
  variant:
    'CALENDAR' | 'MEETING' | 'RECOMMENDATION' | 'HOMEPAGE' | 'KASSENKOMPASS' | 'NOTFALLPLAN' | 'PARTNER' | 'CUSTOM';
  url: string;
}

export interface CustomLinkRequestModel {
  title: string;
  description: string | null;
  url: string;
}

export interface CustomLinkResponseModel {
  id: number;
  title: string;
  description: string | null;
  url: string;
}
